<div class="row container_fieldset" style="margin-top: 20px; margin-bottom: 10px;">
    <fieldset style="margin-bottom: 15px;">
        <legend>
            <div class="row">
                <div class="col-sm-8">
                    {{file.nomeFile}}
                </div>
                <div class="col-sm-4">
                    <div class="actions" style="text-align: right;">
                        <span *ngIf="iconSign" [appTooltip]="iconSign.tooltip" [appTooltipEnabled]="true" class="glyphicon {{iconSign.label}}"></span>
                        <button 
                            *ngIf="canExtract && !nuovaVersione"
                            type="button" 
                            role="button" 
                            class="btn-link" 
                            (click)="extractContent(file)" 
                            aria-label="Estrai contenuto"
                            [appTooltip]="'Estrai contenuto'" 
                            [appTooltipEnabled]="true">
                                <span class="glyphicon glyphicon-save"></span>
                        </button>
                        <button
                            *ngIf="canAddDetail"
                            type="button" 
                            role="button" 
                            class="btn-link" 
                            (click)="addDetail(file)" 
                            aria-label="Aggiungi dettaglio documenti"
                            [appTooltip]="'Aggiungi dettaglio documenti'" 
                            [appTooltipEnabled]="true">
                                <span class="glyphicon glyphicon-plus"></span>
                        </button>
                        <button 
                            type="button" 
                            role="button" 
                            class="btn-link" 
                            (click)="deleteFile(indexFile)" 
                            aria-label="Aggiungi dettaglio documenti"
                            [appTooltip]="'Elimina file'" 
                            [appTooltipEnabled]="true">
                                <span class="glyphicon glyphicon-trash"></span>
                        </button>
                    </div>
                </div>
            </div>
        </legend>
        <div class="row">
            <div class="col-sm-12">
                <small id="upload-form-{{file.refDocumentale}}" class="sr-only">Form dati caricamento file {{file.nomeFile}}</small>
                <form *ngIf="uploadForm" aria-labelledby="upload-form-{{file.refDocumentale}}" [formGroup]="uploadForm">
                    <div *ngFor="let question of questions" class="{{question.size}}">
                        <dynamic-form-field [form]="uploadForm" [question]="question"></dynamic-form-field>
                    </div>
                </form>
            </div>
            <div class="col-sm-12" *ngIf="canAddDetail">
                <app-detail-table [file]="file" [isSigned]="uploadConfig.hasSign" (onRowsNumberChanges)="onDetaillengthChange($event)" (onRowsChanges)="onDetailChange($event)" #detailTable></app-detail-table>
            </div>

        </div>
        <div class="row" *ngIf="file?.signedData && !uploadConfig.signValid && file.signedData?.statoFirma !== 'ASSENTE' && file.signedData?.statoFirma !== 'NON_SUPPORTATO'">
            <div class="col-sm-12">
                <div>

                    <!-- DETTAGLIO GENERALE -->
                    <div *ngIf="file.signedData?.dettaglio" class="text-danger">
                        <strong>{{ file.signedData.dettaglio }}</strong>
                    </div>

                    <!-- DETTAGLIO FIRME -->
                    <div *ngIf="invalidSignatures?.length" class="text-danger" style="margin-top: 8px;">
                        <div *ngFor="let sig of invalidSignatures">
                        <strong>
                            Firma di {{ sig.givenName || '' }} {{ sig.surname || '' }} non valida
                        </strong>
                        <ul style="margin-left: 15px;">
                            <li *ngIf="sig.motivoFirmaNonValida">
                            {{ sig.motivoFirmaNonValida }}
                            </li>
                        </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </fieldset>
</div>